import { Typography } from "@earned/core";

interface XAxisTickProps {
  x: number;
  y: number;
  dx?: number;
  dy?: number;
  width: number;
  height: number;
  payload: {
    value: number;
    offset: number;
  };
  tickFormatter: (value: number) => string;
}

const XAxisTick = (props: XAxisTickProps) => {
  const { x, y, dx, dy, width, height, tickFormatter } = props;
  const { offset, value } = props.payload;

  // TODO: measure width of html and calculate midpoint offset
  return (
    <svg>
      <foreignObject
        x={x + (dx ? dx : offset ? -(width / (8 * offset)) : 0)}
        y={y + (dy ? dy : 0)}
        width={width}
        height={height}
      >
        <div className="z-50">
          <Typography variant="body-sm" color="secondary">
            {tickFormatter(value)}
          </Typography>
        </div>
      </foreignObject>
    </svg>
  );
};

export default XAxisTick;
